export default __webpack_public_path__ + "static/media/121t.902b107b.jpg";